module.exports = __webpack_public_path__ + "img/icon_default.399e2036.png";